module.exports = __webpack_public_path__ + "img/46ne.7839e5c1.svg";